import request from './request.js';
import {requestbody} from './request.js'

//上传文件
export async function hgjks_upload (params = {
}) {
return await request('hgjks/file/upload', 'post', params)
}

//查询列表分页
export async function hgjks_query (params = {
}) {
return await requestbody('hgjks/list/query', 'post', params)
}

//明细列表分页
export async function hgjks_detailquery (params = {
}) {
return await requestbody('hgjks/detail/query', 'post', params)
}
// 删除
export async function hgjks_delete(params = {

}){
return await requestbody('hgjks/result/delete', 'post', params)
}